import { gql } from '@apollo/client';

export const ALL_CLEARING_HOUSES_QUERY_NAME = 'AllClearingHouses';
export const ALL_CLEARING_HOUSES = gql`
    query ${ALL_CLEARING_HOUSES_QUERY_NAME}(
        $page: Int, 
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
    ) {
        allClearingHouses(
            page: $page, 
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
        ) {
            minCashLimit
            maxCashLimit
            availableTimeZones {
                ID
            }
            availableCurrencies {
                name
                code
            }
            clearingHouseList {
                totalCount
                models {
                    id
                    name
                    code
                    timeZone {
                        ID
                    }
                    zones {
                        code
                        name
                    }
                    cashLimits {
                        cashLimit
                        currency {
                            code
                        }
                    }
                    modificationBlockers
                    deletionBlockers
                }
            }
        }
    }
`;

export const CREATE_CLEARING_HOUSE = gql`
    mutation CreateClearingHouse(
        $name: String!,
        $code: String!,
        $timeZone: String!,
        $cashLimits: [ClearingHouseLimitInputInput],
        $fourEyesUserId: String,
        $fourEyesPassword: String,
        $correlationId: String!
    ) {
        createClearingHouse(
            name: $name,
            code: $code,
            timeZone: $timeZone,
            cashLimits: $cashLimits,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
            correlationId: $correlationId
        ) {
            name
            code
        }
    }
`;

export const UPDATE_CLEARING_HOUSE = gql`
    mutation UpdateClearingHouse(
        $id: Int!,
        $name: String!,
        $code: String!,
        $timeZone: String!,
        $cashLimits: [ClearingHouseLimitInputInput],
        $fourEyesUserId: String,
        $fourEyesPassword: String,
        $correlationId: String!
    ) {
        updateClearingHouse(
            id: $id,
            name: $name,
            code: $code,
            timeZone: $timeZone,
            cashLimits: $cashLimits,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
            correlationId: $correlationId
        ) {
            name
            code
        }
    }
`;

export const ON_CLEARING_HOUSE_CHANGE = gql`
    subscription onClearingHouseChanged {
        clearingHouseChanged {
            correlationId
            action
            model {
                name
                code
            }
        }
    }
`;

export const DELETE_CLEARING_HOUSE = gql`
    mutation DeleteClearingHouse(
        $id: Int!, 
        $correlationId: String!,
        $fourEyesUserId: String,
        $fourEyesPassword: String,
    ) {
        deleteClearingHouse(
            id: $id, 
            correlationId: $correlationId,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
        ) {
            name
            code
        }
    }
`;
